// extracted by mini-css-extract-plugin
var _1 = "DashboardTile-modulechart__X0c6Z";
var _2 = "DashboardTile-modulechartSkeleton__BQR87 Skeleton-moduleSkeleton__Mlrfv";
var _3 = "DashboardTile-moduledetails__J_VpB";
var _4 = "DashboardTile-moduleinteractive__bTW0H";
var _5 = "DashboardTile-modulelabel__SBUQl";
var _6 = "DashboardTile-modulelabelSkeleton__aMM8y Skeleton-moduleSkeleton__Mlrfv";
var _7 = "DashboardTile-modulerefreshing__YYxiN";
var _8 = "DashboardTile-moduletile__tbEPQ";
var _9 = "DashboardTile-modulevalue__H2Mrw";
export { _1 as "chart", _2 as "chartSkeleton", _3 as "details", _4 as "interactive", _5 as "label", _6 as "labelSkeleton", _7 as "refreshing", _8 as "tile", _9 as "value" }
